import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
import { trackAddToCart } from '../../utils/metaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showIcon?: boolean;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  showIcon = true,
  fullWidth = false,
  href = 'https://www.mareaa.online/cart',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500';
  const variants = {
    primary: 'bg-rose-500 text-white hover:bg-rose-600 shadow-lg shadow-rose-500/30',
    secondary: 'bg-gold-500 text-white hover:bg-gold-600 shadow-lg shadow-gold-500/30',
    outline: 'border-2 border-rose-500 text-rose-500 hover:bg-rose-50'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  const content = <>
      {children}
      {showIcon && <ShoppingCart className="ml-2 w-5 h-5" data-id="element-264" />}
    </>;
  if (href) {
    return <motion.a href={href} className={classes} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.98
    }} style={{
      textDecoration: 'none'
    }} onClick={() => trackAddToCart()} data-id="element-265">
        {content}
      </motion.a>;
  }
  return <motion.button className={classes} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-266">
      {content}
    </motion.button>;
}